export default "__VITE_ASSET__Co$K1IhY__"